export default {"src":"/uk/_next/static/media/down-filled.cbfc4c39.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};